import { render, staticRenderFns } from "./ComprobanteCompra.vue?vue&type=template&id=851e5276&scoped=true"
import script from "./ComprobanteCompra.vue?vue&type=script&lang=js"
export * from "./ComprobanteCompra.vue?vue&type=script&lang=js"
import style0 from "./ComprobanteCompra.vue?vue&type=style&index=0&id=851e5276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851e5276",
  null
  
)

export default component.exports